import { requestBlob, requestJson } from "../lib/api";

export function listUsers({ page = 1, pageSize = 20, q = "" } = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));

  const query = String(q ?? "").trim();
  if (query) {
    params.set("q", query);
  }

  return requestJson(`/api/users?${params.toString()}`);
}

export function exportUsers({ q = "" } = {}) {
  const params = new URLSearchParams();

  const query = String(q ?? "").trim();
  if (query) {
    params.set("q", query);
  }

  const path = params.toString() ? `/api/users/export?${params.toString()}` : "/api/users/export";

  return requestBlob(path);
}

export function promoteUserToAdmin(userId) {
  return requestJson(`/api/users/${encodeURIComponent(userId)}/role`, {
    method: "PATCH",
  });
}

export function updateUser(userId, payload) {
  return requestJson(`/api/users/${encodeURIComponent(userId)}`, {
    method: "PATCH",
    body: payload,
  });
}

export function disableUser(userId) {
  return requestJson(`/api/users/${encodeURIComponent(userId)}/disable`, {
    method: "PATCH",
  });
}

export function enableUser(userId) {
  return requestJson(`/api/users/${encodeURIComponent(userId)}/enable`, {
    method: "PATCH",
  });
}

export function createAdminUser(payload) {
  return requestJson("/api/users/admins", {
    method: "POST",
    body: payload,
  });
}
